// export all pages in a single object
import HomePage from './HomePage';
import BrandTopicPage from './BrandTopicPage';
import CategoryPage from './CategoryPage';
import ProductPage from './ProductPage';
import ErrorPage from './ErrorPage';

export {
	HomePage,
	BrandTopicPage,
	CategoryPage,
	ProductPage,
	ErrorPage,
};
